import React from 'react';


export default ({children, styleName}) => {
  var cln = styleName+ " row "; 
  return (
    <div className={cln}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Form/Row.jsx